(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin_kotlin.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin_kotlin.js'));
  else {
    if (typeof kotlin_kotlin === 'undefined') {
      throw new Error("Error loading module 'kotlin_org_jetbrains_kotlinx_atomicfu'. Its dependency 'kotlin_kotlin' was not found. Please, check whether 'kotlin_kotlin' is loaded prior to 'kotlin_org_jetbrains_kotlinx_atomicfu'.");
    }
    root.kotlin_org_jetbrains_kotlinx_atomicfu = factory(typeof kotlin_org_jetbrains_kotlinx_atomicfu === 'undefined' ? {} : kotlin_org_jetbrains_kotlinx_atomicfu, kotlin_kotlin);
  }
}(this, function (_, kotlin_kotlin) {
  //region block: imports
  var toString = kotlin_kotlin.$crossModule$.toString_1;
  //endregion
  'use strict';
  //region block: pre-declaration
  None.prototype = Object.create(atomicfu$TraceBase.prototype);
  None.prototype.constructor = None;
  //endregion
  function None() {
    None_instance = this;
    atomicfu$TraceBase.call(this);
  }
  None.$metadata$ = {
    simpleName: 'None',
    kind: 'object',
    interfaces: []
  };
  var None_instance;
  function None_getInstance() {
    if (None_instance == null)
      new None();
    return None_instance;
  }
  function atomicfu$TraceBase() {
  }
  atomicfu$TraceBase.prototype.atomicfu$Trace$append$1 = function (event) {
  };
  atomicfu$TraceBase.prototype.atomicfu$Trace$append$2 = function (event1, event2) {
  };
  atomicfu$TraceBase.prototype.atomicfu$Trace$append$3 = function (event1, event2, event3) {
  };
  atomicfu$TraceBase.prototype.atomicfu$Trace$append$4 = function (event1, event2, event3, event4) {
  };
  atomicfu$TraceBase.$metadata$ = {
    simpleName: 'TraceBase',
    kind: 'class',
    interfaces: []
  };
  function AtomicRef(value) {
    this.value_1 = value;
  }
  AtomicRef.prototype._set_value__1325260276_x73o94_k$ = function (_set____804775014) {
    this.value_1 = _set____804775014;
  };
  AtomicRef.prototype._get_value__3683422336_a43j40_k$ = function () {
    return this.value_1;
  };
  AtomicRef.prototype.atomicfu$compareAndSet = function (expect, update) {
    if (!(this.value_1 === expect))
      return false;
    this.value_1 = update;
    return true;
  };
  AtomicRef.prototype.atomicfu$getAndSet = function (value) {
    var oldValue = this.value_1;
    this.value_1 = value;
    return oldValue;
  };
  AtomicRef.prototype.toString = function () {
    return toString(this.value_1);
  };
  AtomicRef.$metadata$ = {
    simpleName: 'AtomicRef',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(AtomicRef.prototype, 'kotlinx$atomicfu$value', {
    configurable: true,
    get: AtomicRef.prototype._get_value__3683422336_a43j40_k$,
    set: AtomicRef.prototype._set_value__1325260276_x73o94_k$
  });
  function atomic$ref$1(initial) {
    return atomic(initial, None_getInstance());
  }
  function AtomicBoolean(value) {
    this.value_1 = value;
  }
  AtomicBoolean.prototype._set_value__1325260276_9lpcvp_k$ = function (_set____804775014) {
    this.value_1 = _set____804775014;
  };
  AtomicBoolean.prototype._get_value__3683422336_a43j40_k$ = function () {
    return this.value_1;
  };
  AtomicBoolean.prototype.atomicfu$compareAndSet = function (expect, update) {
    if (!(this.value_1 === expect))
      return false;
    this.value_1 = update;
    return true;
  };
  AtomicBoolean.prototype.atomicfu$getAndSet = function (value) {
    var oldValue = this.value_1;
    this.value_1 = value;
    return oldValue;
  };
  AtomicBoolean.prototype.toString = function () {
    return this.value_1.toString();
  };
  AtomicBoolean.$metadata$ = {
    simpleName: 'AtomicBoolean',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(AtomicBoolean.prototype, 'kotlinx$atomicfu$value', {
    configurable: true,
    get: AtomicBoolean.prototype._get_value__3683422336_a43j40_k$,
    set: AtomicBoolean.prototype._set_value__1325260276_9lpcvp_k$
  });
  function atomic$boolean$1(initial) {
    return atomic_0(initial, None_getInstance());
  }
  function AtomicInt(value) {
    this.value_1 = value;
  }
  AtomicInt.prototype._set_value__1325260276_xwdays_k$ = function (_set____804775014) {
    this.value_1 = _set____804775014;
  };
  AtomicInt.prototype._get_value__3683422336_a43j40_k$ = function () {
    return this.value_1;
  };
  AtomicInt.prototype.atomicfu$compareAndSet = function (expect, update) {
    if (!(this.value_1 === expect))
      return false;
    this.value_1 = update;
    return true;
  };
  AtomicInt.prototype.atomicfu$getAndSet = function (value) {
    var oldValue = this.value_1;
    this.value_1 = value;
    return oldValue;
  };
  AtomicInt.prototype.atomicfu$getAndIncrement = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this.value_1;
    tmp0_this.value_1 = tmp1 + 1 | 0;
    return tmp1;
  };
  AtomicInt.prototype.atomicfu$getAndDecrement = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this.value_1;
    tmp0_this.value_1 = tmp1 - 1 | 0;
    return tmp1;
  };
  AtomicInt.prototype.atomicfu$getAndAdd = function (delta) {
    var oldValue = this.value_1;
    var tmp0_this = this;
    tmp0_this.value_1 = tmp0_this.value_1 + delta | 0;
    return oldValue;
  };
  AtomicInt.prototype.atomicfu$addAndGet = function (delta) {
    var tmp0_this = this;
    tmp0_this.value_1 = tmp0_this.value_1 + delta | 0;
    return this.value_1;
  };
  AtomicInt.prototype.atomicfu$incrementAndGet = function () {
    var tmp0_this = this;
    tmp0_this.value_1 = tmp0_this.value_1 + 1 | 0;
    return tmp0_this.value_1;
  };
  AtomicInt.prototype.atomicfu$decrementAndGet = function () {
    var tmp0_this = this;
    tmp0_this.value_1 = tmp0_this.value_1 - 1 | 0;
    return tmp0_this.value_1;
  };
  AtomicInt.prototype.toString = function () {
    return this.value_1.toString();
  };
  AtomicInt.$metadata$ = {
    simpleName: 'AtomicInt',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(AtomicInt.prototype, 'kotlinx$atomicfu$value', {
    configurable: true,
    get: AtomicInt.prototype._get_value__3683422336_a43j40_k$,
    set: AtomicInt.prototype._set_value__1325260276_xwdays_k$
  });
  function atomic$int$1(initial) {
    return atomic_1(initial, None_getInstance());
  }
  function atomic(initial, trace) {
    return new AtomicRef(initial);
  }
  function atomic_0(initial, trace) {
    return new AtomicBoolean(initial);
  }
  function atomic_1(initial, trace) {
    return new AtomicInt(initial);
  }
  //region block: exports
  _.$crossModule$ = _.$crossModule$ || {};
  _.$crossModule$.atomic$boolean$1 = atomic$boolean$1;
  _.$crossModule$.atomic$ref$1 = atomic$ref$1;
  _.$crossModule$.atomic$int$1 = atomic$int$1;
  //endregion
  return _;
}));

//# sourceMappingURL=kotlin_org_jetbrains_kotlinx_atomicfu.js.map